import { __assign } from "tslib";
import React from "react";
import { Container, Counter, Tab } from "./styles";
var Tabs = function (_a) {
    var tabs = _a.tabs, selected = _a.selected, counter = _a.counter, onChangeTab = _a.onChangeTab, horizontalPadding = _a.horizontalPadding, mediaQueries = _a.mediaQueries, containerStyles = _a.containerStyles, tabStyles = _a.tabStyles, tabSelectedStyles = _a.tabSelectedStyles;
    return (React.createElement(Container, { style: containerStyles }, tabs.map(function (tab, idx) {
        return (React.createElement(Tab, { horizontalPadding: horizontalPadding, mediaQueries: mediaQueries, key: idx, id: "".concat(idx), selected: selected === idx, onClick: function () { return onChangeTab(idx); }, style: __assign(__assign({}, tabStyles), (selected === idx && tabSelectedStyles)) },
            React.createElement("span", null, tab),
            counter && counter[idx] !== null && (React.createElement(Counter, null, counter[idx]))));
    })));
};
Tabs.defaultProps = {
    tabs: [],
    selected: 0,
    counter: undefined,
    horizontalPadding: undefined,
    mediaQueries: undefined,
    containerStyles: undefined,
    tabStyles: undefined,
    tabSelectedStyles: undefined
};
export default Tabs;
//# sourceMappingURL=index.js.map